"use client";

import Link from "next/link";
import { usePathname } from "next/navigation";
import React, { useState } from "react";

type Props = {
  page?: number;
  pages?: number;
};

export default function PaginationMenu({ page, pages }: Props) {
  const [currentPage, setCurrentPage] = useState(page || 1);

  const pathname = usePathname();

  if (!pages || pages < 2) {
    return null;
  }

  return (
    <ul className="pagination__menu">
      {[...Array(pages)].map((_, index) => {
        const i = index + 1;

        return (
          <li className="pagination__menu__item" key={index}>
            {currentPage === i ? (
              <Link
                href="#"
                className="pagination__menu__link pagination__menu__link--is-active"
                aria-current="page"
                aria-label={"Page " + i}
              >
                {i}
              </Link>
            ) : (
              <Link
                href={`${
                  (pathname && pathname.replace(/\/(\d+)$/, "")) || ""
                }/${i}`}
                className="pagination__menu__link"
                aria-label={"Go to page " + i}
                onClick={() => setCurrentPage(i)}
              >
                {i}
              </Link>
            )}
          </li>
        );
      })}
    </ul>
  );
}
